export default __webpack_public_path__ + "static/media/HomeGarden.5ebdc32f.svg";